import { MasterAPIService } from "@app/services/Methods/api";
import { SalesChannelFormData } from "@app/types/SalesChannel.types";

export const getSalesChannels = (
    sortBy: string,
    sortOrder: number,
    pageNumber: number,
    pageSize: number,
    name?: string,
    filters?: string,
) =>
    MasterAPIService.get(
        `/saleschannel?${sortBy ? `sortBy=${sortBy}&` : ""}${sortOrder ? `sortOrder=${sortOrder}&` : ""
        }${pageNumber ? `pageNumber=${pageNumber}&` : ""}${pageSize ? `pageSize=${pageSize}&` : ""
        }${name ? `name=${name}&` : ""}${filters ? filters : ""}`,
    );

export const getSalesChannelById = (id: string) =>
    MasterAPIService.get(`/saleschannel/GetSalesChannelById?salesChannelId=${id}`);

export const createSalesChannel = (data: SalesChannelFormData) =>
    MasterAPIService.post<SalesChannelFormData>("/saleschannel", data);

export const updateSalesChannel = (data: Partial<SalesChannelFormData>) =>
    MasterAPIService.patch<Partial<SalesChannelFormData>>("/saleschannel", data);

